module.exports = __webpack_public_path__ + "static/media/7949c1e0-9273-4874-a6d6-2012f5b7c8ee_2.7d75522685dcbbb3b7625b85fec7d8c7.8764dad2.jpeg";